var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-shadow",style:(_vm.shadowStyle)},[_c('div',{staticClass:"xt-shadow-before"}),_vm._v(" "),_c('div',{staticClass:"xt-shadow-after",style:(_vm.afterStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }